import React from 'react';
import { motion } from 'framer-motion';
import Header from './Header';
import LivePrices from '../PriceTicker/LivePrices';
import { TabType } from '../../types';

interface LayoutProps {
  children: React.ReactNode;
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

const Layout: React.FC<LayoutProps> = ({ children, activeTab, onTabChange }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-950 via-black to-gray-900 relative overflow-hidden">
      {/* Modern background decoration - hidden on mobile for performance */}
      <div className="hidden md:block fixed inset-0 overflow-hidden pointer-events-none">
        {/* Subtle logo pattern background */}
        <div className="absolute inset-0 opacity-[0.02]">
          <div className="absolute top-20 left-20">
            <img src="/eredium-logo.svg" alt="" className="w-12 h-12 animate-glow-rotate" style={{animationDuration: '20s'}} />
          </div>
          <div className="absolute top-40 right-32">
            <img src="/eredium-logo.svg" alt="" className="w-8 h-8 animate-glow-rotate" style={{animationDuration: '25s', animationDelay: '5s'}} />
          </div>
          <div className="absolute bottom-32 left-1/3">
            <img src="/eredium-logo.svg" alt="" className="w-10 h-10 animate-glow-rotate" style={{animationDuration: '30s', animationDelay: '10s'}} />
          </div>
          <div className="absolute bottom-20 right-20">
            <img src="/eredium-logo.svg" alt="" className="w-6 h-6 animate-glow-rotate" style={{animationDuration: '22s', animationDelay: '15s'}} />
          </div>
        </div>
        
        {/* Grid pattern overlay */}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:50px_50px]"></div>
      </div>
      
      <div className="relative z-10">
        <div className="container mx-auto px-2 sm:px-4 py-2 sm:py-4 max-w-7xl">
          <Header activeTab={activeTab} onTabChange={onTabChange} />
        </div>
        
        {/* Live Prices Ticker */}
        <LivePrices />
        
        <div className="container mx-auto px-2 sm:px-4 py-2 sm:py-4 max-w-7xl">
          <motion.main
            key={activeTab}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            className="relative"
          >
            {children}
          </motion.main>
        </div>
      </div>
    </div>
  );
};

export default Layout;
